import { useGetSuggestedAssets } from '../hooks/useGetSuggestionAssets';
import { AssetLineItem } from './AssetLineItem';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { Button, Typography } from '@mui/material';
import { THEME_COLORS } from '../../common/colors';

const SHOW_MORE_INCREMENT = 4;
const SHOW_MORE_INCREMENT_MOBILE = 2;

const AssetHeader = styled(Typography)`
  font-weight: 500 !important;
  font-size: 1.5rem !important;
  display: block !important;
  text-align: center;
  width: 100%;
  margin: 24px 0;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ShowMoreButton = styled(Button)`
  background-color: ${THEME_COLORS.primary} !important;
  box-shadow: unset !important;
  border-radius: 12px !important;
  ${({ isMobile }) =>
    isMobile &&
    `
    border-top-right-radius: 0 !important;
    border-top-left-radius: 0 !important;
    border-bottom-right-radius: 16px !important;
    border-bottom-left-radius: 16px !important;
  `}
  font-weight: 800 !important;
  font-size: 0.83rem;
  padding: ${({ isMobile }) => (isMobile ? 8 : 6)}px 10px !important;
  text-transform: capitalize !important;
  width: ${({ isMobile }) => (isMobile ? '100%' : '85px')} !important;
`;

export function SuggestedAssetList({ isMobile, userUuid, increment }) {
  const calculatedIncrement =
    increment ?? (isMobile ? SHOW_MORE_INCREMENT_MOBILE : SHOW_MORE_INCREMENT);
  const { suggestedAssets, loading } = useGetSuggestedAssets(userUuid);
  const [showMoreMatches, setShowMoreMatches] = useState(calculatedIncrement);
  const [showMoreRecommended, setShowMoreRecommended] = useState(
    calculatedIncrement,
  );

  const handleShowMoreMatches = useCallback(() => {
    setShowMoreMatches(showMoreMatches + calculatedIncrement);
  }, [showMoreMatches, setShowMoreMatches]);

  const handleShowMoreRecommended = useCallback(() => {
    setShowMoreRecommended(showMoreRecommended + calculatedIncrement);
  }, [showMoreRecommended, setShowMoreRecommended]);

  return (
    <List>
      {suggestedAssets.matches.length === 0 && !loading && (
        <AssetHeader isMobile={isMobile}>
          Sorry! No exact matches for your goals
        </AssetHeader>
      )}
      {suggestedAssets.matches.slice(0, showMoreMatches).map((asset, idx) => (
        <AssetLineItem
          key={asset.uuid}
          asset={asset}
          isMobile={isMobile}
          showBorder={idx !== suggestedAssets.matches.length - 1}
        />
      ))}
      {suggestedAssets.matches.length > showMoreMatches && (
        <ShowMoreButton
          type="submit"
          variant="contained"
          color="primary"
          size="small"
          onClick={handleShowMoreMatches}
          isMobile={isMobile}
        >
          Show more
        </ShowMoreButton>
      )}
      {suggestedAssets.matches.length <= showMoreMatches &&
        suggestedAssets.recommended.length > 0 && (
          <>
            <AssetHeader isMobile={isMobile}>You may also like</AssetHeader>
            {suggestedAssets.recommended
              .slice(0, showMoreRecommended)
              .map((asset, idx) => (
                <AssetLineItem
                  key={asset.uuid}
                  asset={asset}
                  isMobile={isMobile}
                  showBorder={idx !== suggestedAssets.matches.length - 1}
                />
              ))}
          </>
        )}
      {suggestedAssets.matches.length <= showMoreMatches &&
        suggestedAssets.recommended.length > showMoreRecommended && (
          <ShowMoreButton
            type="submit"
            variant="contained"
            color="primary"
            size="small"
            onClick={handleShowMoreRecommended}
            isMobile={isMobile}
          >
            Show more
          </ShowMoreButton>
        )}
    </List>
  );
}
